module.exports = __webpack_public_path__ + "img/更多资本服务.34b3f27e.png";